<template>
  <div ref="image" class="font-images">
    <div class="font-images-wrapper">
      <div v-for="(img, index) in v" :key="index" class="font-images-item"><img :src="img" alt=""></div>
    </div>
    <div v-if="v.length > 1" class="swiper-button">
      <button type="button" class="swiper-button-prev"><icon-chevron-left /></button>
      <button type="button" class="swiper-button-next"><icon-chevron-right /></button>
    </div>
  </div>
</template>

<script>
import Swiper, { Navigation, EffectFade } from 'swiper'
Swiper.use([Navigation, EffectFade])

export default {
  components: {
    iconChevronLeft: () => import('@/static/svg/chevron-left-big.svg'),
    iconChevronRight: () => import('@/static/svg/chevron-right-big.svg'),
  },
  props: {
    v: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.setSlider()
  },
  methods: {
    setSlider () {
      if (this.v.length > 0) {
        // eslint-disable-next-line no-new
        new Swiper(this.$refs.image, {
          loop: true,
          slideClass: 'font-images-item',
          wrapperClass: 'font-images-wrapper',
          pagination: false,
          // simulateTouch: false,
          spaceBetween: 0,
          slidesPerView: 1,
          autoplay: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          // breakpoints: {
          //   779: {
          //   }
          // }
        })
      }
    }
  }
}
</script>
